export default {
  addProducts: "Add Products...",
  parseProducts: "Batch pad add products...",
  addList: "Create List...",
  deleteList: "Delete List...",
  emailList: "Email List...",
  printList: "Print List...",
  applyTags: "Apply Tags to List...",
  editCustomers: "Edit Customers...",
  editListSettings: "Edit List Settings..."
};
